import Lookup from 'src/componentes/select2';

const TipoTolerancia = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/TipoToleranciaLookup"
      {...props}
    />
  );
};

export default TipoTolerancia;
